import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class CategoryService extends BaseService {

    static url = "categories";
    static apis = {
        that: this,
        getTree: this.url + "/tree",
        getSpecs: function (id) {
            return this.that.url + "/" + id + "/specs"
        },
        getLogos : function(){
            return "categories-logos"
        },
      
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("categories");
    }

    
    getSpecs(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CategoryService.apis.getSpecs(id), method: "GET", authorization: false, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    
    getLogos() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: CategoryService.apis.getLogos(), method: "GET", authorization: false, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getTree(data) {
        var that = this;
        var inUrlParams = (data != undefined) ? ApiHelper.buildInlineParams(data) : '';
        return new Promise((resolve, reject) => {
            that.axios({ url: CategoryService.apis.getTree.concat(inUrlParams), method: "GET", authorization: false, showLoader: false })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default CategoryService;